import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ProcessMonitorLogSeverity from '@linc-technologies/linced-common/enums/process-monitor-log-severity';

// Proto: cron.ProcessMonitorError.
export default class ProcessMonitorError extends Fragment {
  declare [Type]: 'cron/process-monitor-error';

  @attr('number', { defaultValue: 0 })
  declare severity: EnumValue<typeof ProcessMonitorLogSeverity> | 0;

  @attr('string', { defaultValue: '' })
  declare message: string;
}
